module.exports = __webpack_public_path__ + "5329388bfc2329edd620c5ea8a9df0cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2024-Clean-200-figure-1.png
// module id = 1502
// module chunks = 0